import { Route, Routes } from "react-router-dom";
import NavBar from '../components/NavBar';
import MortgageModeller from "../pages/MortgageModeller";
import Home from "../pages/Home";
import { useState } from "react";
import { PaletteMode, ThemeOptions, ThemeProvider, createTheme } from "@mui/material";
import { MortgageContextProvider } from "../contexts/MortgageContextProvider";
import AuthProvider from "../contexts/AuthProvider";
import UserInputProvider from "../contexts/UserInputProvider";
import Footer from "../components/Footer";

const Main = () => {
  const [theme, setTheme] = useState<string>("cupcake");
  var [darkTheme, setDarkTheme] = useState<ThemeOptions>(createTheme({
    palette: {
      mode: 'light',
    },
  }));

  function handleDarkMode(data: { darkMode: boolean, theme: string }) {
    setTheme(data.theme);
    let dark: PaletteMode = data.darkMode ? 'dark' : 'light'
    setDarkTheme(createTheme({
      palette: {
        mode: dark,
      },
    }));
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <html data-theme={theme}>
        <AuthProvider>
          <UserInputProvider>
            <NavBar updateData={handleDarkMode} />
            <MortgageContextProvider>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/modeller" element={<MortgageModeller />} />
              </Routes>
            </MortgageContextProvider>
            <Footer />
          </UserInputProvider>
        </AuthProvider>
      </html>
    </ThemeProvider>
  );
}
export default Main;